import { useCallback, useState } from 'react';
import { ZIP_LAYER_MIN_ZOOM } from '../utils/constants';
import { fetchMarketNearby } from '../utils/api';
import * as Sentry from '@sentry/react';

export default function useMarketOverviewMode(
  mediacode,
  onSelectMarket,
  selectedProdcode,
) {
  const [zoom, setZoom] = useState(null);

  const isOverviewMode =
    (zoom !== null && zoom < ZIP_LAYER_MIN_ZOOM) || selectedProdcode === '';

  const handleZoomChange = useCallback(
    (zoom, latLng) => {
      // we are zooming in to somewhere from the overview mode - let's find and select the nearest market
      if (isOverviewMode && zoom >= ZIP_LAYER_MIN_ZOOM) {
        fetchMarketNearby(latLng.lat, latLng.lng, mediacode)
          .then((prodcode) => {
            onSelectMarket(prodcode, undefined);
          })
          .catch((err) => {
            Sentry.captureException(err + 'Error in handleZoomChange');
          });
      }
      if (zoom < ZIP_LAYER_MIN_ZOOM && selectedProdcode !== '') {
        onSelectMarket('', undefined);
      }
      setZoom(zoom);
    },
    [onSelectMarket, isOverviewMode, selectedProdcode, mediacode],
  );

  return [isOverviewMode, handleZoomChange];
}
